import type { ComponentProps } from 'react';
import type { ProjectFileResponseDto } from '@inference.engine/workspace-api-client/web';
import type { Badge } from '@monksflow/monks-ui';
import { i18n } from '@/shared/i18n';

// Labels are getters so each read resolves against the active locale; a plain
// `i18n.t(...)` here would freeze the English string at import time.
export const FILE_STATUS_CONFIG: Record<
  ProjectFileResponseDto['status'],
  {
    label: string;
    variant: ComponentProps<typeof Badge>['variant'];
  }
> = {
  approved: {
    get label() {
      return i18n.t('projects:projectDetail.foldersConstants.approved');
    },
    variant: 'positive',
  },
  rejected: {
    get label() {
      return i18n.t('projects:projectDetail.foldersConstants.rejected');
    },
    variant: 'destructive',
  },
  to_review: {
    get label() {
      return i18n.t('projects:projectDetail.foldersConstants.inReview');
    },
    variant: 'warning',
  },
  not_applicable: {
    get label() {
      return i18n.t('projects:projectDetail.foldersConstants.na');
    },
    variant: 'ghost',
  },
};

/**
 * How deep folders may nest. A top-level folder is depth 1, so a folder at this
 * depth can only take assets.
 */
export const MAX_FOLDER_DEPTH = 3;
